import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleSettingsViewDialogTourConfig: AgTechTourConfig = {
    id: 'sale-settings-view-dialog-tour',
    name: 'My Sale Settings Tour',
    steps: [
        {
            targetId: 'sale-settings-lot-categories-tab',
            title: 'Lot Categories',
            description: 'Create and manage lot categories used to organize and classify lots across your sales.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-lot-categories-tab')?.click(),
        },
        {
            targetId: 'sale-settings-charges-discounts-tab',
            title: 'Charges and Discounts',
            description: 'Configure invoice modifiers such as buyer\'s premiums, fees, and discounts that apply to invoices.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-charges-discounts-tab')?.click(),
        },
        {
            targetId: 'sale-settings-document-headers-tab',
            title: 'Document Headers',
            description: 'Set up the header content that appears at the top of printed documents like sale bills and invoices.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-document-headers-tab')?.click(),
        },
        {
            targetId: 'sale-settings-invoice-fields-tab',
            title: 'Invoice Fields',
            description: 'Control which fields are shown on generated invoice documents.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-invoice-fields-tab')?.click(),
        },
        {
            targetId: 'sale-settings-logo-tab',
            title: 'Logo',
            description: 'Upload and manage your operation\'s logo, which appears on printed documents.',
            position: 'right',
            onActivate: () => document.getElementById('sale-settings-logo-tab')?.click(),
        },
    ]
}
